import { CustodianSettingsState, InvestmentCustodian } from "@/shared/types";
import Vue from "vue";

import * as allegacyEmployeeSettings from "@/shared/custodianSettings/employee/allegacy";
import * as umbEmployeeSettings from "@/shared/custodianSettings/employee/umb";
import * as elementsEmployeeSettings from "@/shared/custodianSettings/employee/elements";
import * as ucbEmployeeSettings from "@/shared/custodianSettings/employee/ucb";
import * as avidiaEmployeeSettings from "@/shared/custodianSettings/employee/avidia";
import * as hsaBankEmployeeSettings from "@/shared/custodianSettings/employee/hsaBank";
import * as omnibusEmployeeSettings from "@/shared/custodianSettings/employee/omnibus";

import * as umbEmployerSettings from "@/shared/custodianSettings/employer/umb";
import * as elementsEmployerSettings from "@/shared/custodianSettings/employer/elements";
import * as ucbEmployerSettings from "@/shared/custodianSettings/employer/ucb";
import * as avidiaEmployerSettings from "@/shared/custodianSettings/employer/avidia";
import * as allegacyEmployerSettings from "@/shared/custodianSettings/employer/allegacy";
import * as hsaBankEmployerSettings from "@/shared/custodianSettings/employer/hsaBank";
import * as omnibusEmployerSettings from "@/shared/custodianSettings/employer/omnibus";

import { BankCustodian } from "@/admin/types";

export function SetElementsUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, elementsEmployeeSettings);
}

export function SetAllegacyUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, allegacyEmployeeSettings);
}

export function SetUmbUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, umbEmployeeSettings);
}

export function SetUcbUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, ucbEmployeeSettings);
}

export function SetAvidiaUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, avidiaEmployeeSettings);
}

export function SetHsaBankUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, hsaBankEmployeeSettings);
}

export function SetOmnibusUserSettings (state: CustodianSettingsState) {
  return formatEmployeeSettings(state, omnibusEmployeeSettings);
}

export function SetElementsEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, elementsEmployerSettings);
}

export function SetUmbEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, umbEmployerSettings);
}

export function SetUcbEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, ucbEmployerSettings);
}

export function SetAvidiaEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, avidiaEmployerSettings);
}

export function SetAllegacyEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, allegacyEmployerSettings);
}

export function SetHsaBankEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, hsaBankEmployerSettings);
}

export function SetOmnibusEmployerSettings (state: CustodianSettingsState) {
  return formatEmployerSettings(state, omnibusEmployerSettings);
}

function formatEmployeeSettings (state: CustodianSettingsState, settings: any) {
  const mergedState = {...state.userCustodianSettings, ...settings};

  Vue.set(state, "userCustodianSettings", mergedState);

  return state;
}

function formatEmployerSettings (state: CustodianSettingsState, settings: any) {
  const mergedState = {...state.employerCustodianSettings, ...settings};

  Vue.set(state, "employerCustodianSettings", mergedState);

  return state;
}

interface CustodianDisplayName {
  key: BankCustodian;
  displayName: string;
}

const add = (key: BankCustodian, displayName: string): CustodianDisplayName => ({key, displayName});

const custodianDisplayNames: CustodianDisplayName[] = [
  add(BankCustodian.Avidia, "Avidia"),
  add(BankCustodian.Elements, "Elements"),
  add(BankCustodian.Ucb, "UCB"),
  add(BankCustodian.Umb, "UMB"),
  add(BankCustodian.Allegacy, "Allegacy"),
  add(BankCustodian.HsaBank, "HSA Bank"),
  add(BankCustodian.None, "No Custodian"),
];

export function custodianDisplayName (bankCustodian: BankCustodian) {
  const pair = custodianDisplayNames.find(x => x.key === bankCustodian);
  if (pair) {
    return pair.displayName;
  }

  return `No display name for ${bankCustodian}`;
}

export function custodianFromDisplayName (displayName: string) {
  const pair = custodianDisplayNames.find(x => x.displayName === displayName);
  if (pair) {
    return pair.key;
  }

  return BankCustodian.None;
}